const Example = {
    namespaced: true,
    state: {
        // activePage: 1,
    },
    mutations: {
        // setActivePage (state, page) {
        //     state.activePage = page
        // },
    },
    actions: {},
    getters: {}
};

export default Example
